export default __webpack_public_path__ + "static/media/join-speakers-specialists.bd9a6cbe.png";